export const DEFAULT_DASHBOARD_SHORTCUT_IDS = [
  "nfe",
  "vendas",
  "orcamento",
  "pedidos",
  "nfse",
  "ordensServicos",
  "prospect",
];

export const MAX_DASHBOARD_SHORTCUTS = 7;

const LEGACY_SHORTCUT_ROUTES = {
  nfe: { name: "nfeNova" },
  vendas: { name: "vendasNovo" },
  orcamento: { name: "orcamentoNovo" },
  pedidos: { name: "pedidosNovo" },
  nfse: { name: "nova-nfseServicos" },
  ordensServicos: { name: "ordensServicosNova" },
  prospect: { name: "linkProspect" },
};

const LEGACY_SHORTCUT_LABELS = {
  nfe: "NFe",
  vendas: "NFCe",
  orcamento: "Orçamentos",
  pedidos: "Pedidos",
  nfse: "NFSe",
  ordensServicos: "OS",
  prospect: "Atendimento",
};

export function getAvailableDashboardShortcutGroups(resources = []) {
  if (!Array.isArray(resources)) return [];

  const seen = new Set();

  return resources.reduce((groups, menu) => {
    if (!menu?.checked || !Array.isArray(menu.submenus)) return groups;

    const shortcuts = menu.submenus.reduce((items, submenu) => {
      const id =
        typeof submenu?.url === "string"
          ? submenu.url.replace(/^\/+|\/+$/g, "").trim()
          : "";

      if (!id || !submenu.checked || submenu.disabled || seen.has(id)) {
        return items;
      }

      seen.add(id);
      items.push({
        id,
        label: submenu.name || id,
        shortcutLabel: LEGACY_SHORTCUT_LABELS[id] || submenu.name || id,
        group: menu.name || "Outros",
      });
      return items;
    }, []);

    if (shortcuts.length) {
      groups.push({
        name: menu.name || "Outros",
        shortcuts,
      });
    }

    return groups;
  }, []);
}

export function flattenDashboardShortcutGroups(groups = []) {
  return groups.reduce(
    (shortcuts, group) => shortcuts.concat(group.shortcuts || []),
    []
  );
}

export function sanitizeDashboardShortcutIds(ids, availableShortcuts = []) {
  if (!Array.isArray(ids)) return [];

  const availableIds = new Set(
    availableShortcuts.map((shortcut) => shortcut.id)
  );
  const seen = new Set();

  return ids.reduce((sanitized, id) => {
    if (sanitized.length >= MAX_DASHBOARD_SHORTCUTS) return sanitized;

    const normalized =
      typeof id === "string" ? id.replace(/^\/+|\/+$/g, "").trim() : "";

    if (normalized && availableIds.has(normalized) && !seen.has(normalized)) {
      seen.add(normalized);
      sanitized.push(normalized);
    }

    return sanitized;
  }, []);
}

export function getSelectedDashboardShortcutIds(
  savedIds,
  availableShortcuts = []
) {
  const source =
    savedIds === null || savedIds === undefined
      ? DEFAULT_DASHBOARD_SHORTCUT_IDS
      : savedIds;

  return sanitizeDashboardShortcutIds(source, availableShortcuts);
}

export function getDashboardShortcutLocation(shortcutId) {
  return (
    LEGACY_SHORTCUT_ROUTES[shortcutId] || {
      path: `/${shortcutId}`,
    }
  );
}
